import React from 'react';

import ComponentSpinner from '@components/spinner/Loading-spinner';

import './styles.scss';

type LoadingProps = {
  blocking?: boolean;
};

export const Loading: React.FC<LoadingProps> = ({ blocking = false }) => {
  return (
    <div>
      {blocking ? (
        <div id="modal-root">
          <div className="spinner-box">
            <ComponentSpinner />
          </div>

          <span className="mt-1">Aguarde...</span>
        </div>
      ) : null}
    </div>
  );
};
